import { getConditionDBString, getStyleDBString } from "./ConditionalFormattingUtils.js"; // Conditional formatting API utils in a separate file
// to make ConditionalFormattingUtils.ts easier to test.
// https://github.com/facebook/jest/issues/936#issuecomment-545080082
export function makeTernaryFormatRule(dh, config, prevRule) {
  var styleDBString = getStyleDBString(config);
  if (styleDBString === undefined) {
    return undefined;
  }
  var conditionDBString = getConditionDBString(dh, config);
  return "".concat(conditionDBString, " ? ").concat(styleDBString, " : ").concat(prevRule);
}
export function makeRowFormatColumn(dh, rule) {
  return dh.Column.formatRowColor(rule);
}
export function makeColumnFormatColumn(col, rule) {
  return col.formatColor(rule);
}
//# sourceMappingURL=ConditionalFormattingAPIUtils.js.map